import {ApiClient} from '@hconnect/apiclient'
import {EventSearchCriteria, EventSearchDto} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export type UseEventsSearchApiParams = {
  plantId: string
  criteria: EventSearchCriteria
}

export type UseEventsSearchApiOptions<TData = EventSearchDto> = Omit<
  UseQueryOptions<EventSearchDto, AxiosError, TData>,
  'queryKey' | 'queryFn'
>

export const EventsSearchQueryKey = 'events-search'

export const useEventsSearchApi = <TData = EventSearchDto>(
  {plantId, criteria}: UseEventsSearchApiParams,
  options?: UseEventsSearchApiOptions<TData>
) => {
  return useQuery<EventSearchDto, AxiosError, TData>({
    queryKey: [EventsSearchQueryKey, plantId, criteria],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.post<EventSearchDto>(
        `/shifthandover/${plantId}/search/events`,
        criteria,
        {signal}
      )
      return response.data
    },
    ...options
  })
}
